import 'css-chunksrc/client/scenes/projectPortfolioRemoval/styles.scss';export default {
  "header": "_header_1q97l_1",
  "text": "_text_1q97l_5",
  "name": "_name_1q97l_10",
  "main": "_main_1q97l_16",
  "buttons": "_buttons_1q97l_24"
};